import {inject, Injectable, signal} from '@angular/core';
import {DialogService} from 'primeng/dynamicdialog';
import {DialogFooterComponent} from '../../../shared/components/dialog-footer/dialog-footer';
import {MailboxConfiguratorComponent} from '../components/shell/mailbox-configurator.component';

@Injectable({
	providedIn: 'root'
})
export class MailboxDialogService {
	private dialogService: DialogService = inject(DialogService)

	private readonly _open = signal(false);
	readonly isOpen = this._open.asReadonly();

	openMailboxDialog(isNewConfig = false) {
		if (this._open()) return;

		this._open.set(true);

		const dialogRef = this.dialogService.open(MailboxConfiguratorComponent, {
			header: 'Configurazione Mailbox',
			width: isNewConfig ? '40vw' : '60vw',
			height: isNewConfig ? '90vh' : '80vh',
			closable: !isNewConfig,
			modal: true,
			baseZIndex: 10000,
			templates: {
				footer: DialogFooterComponent
			}
		});

		dialogRef?.onClose.subscribe(() => {
			this._open.set(false);
		});

		return dialogRef?.onClose
	}
}
